<template>
    <AdminsEdit />
</template>

<script>
import {
    mapActions
} from 'vuex'

import AdminsEdit from '../components/AdminPanelAdminsEdit.vue'

export default {
    data: () => ({}),
    components: {
        AdminsEdit
    },
    methods: {},
    mounted() {}
}
</script>
